export default [
    {
        path: 'driverManage',
        name: {list:['数字物流','司机','司机信息','司机管理']},
        component: () => import('@/views/digitalLogistics/driverManage.vue')
    },
    {
        path: 'driverAuthen',
        name: {list:['数字物流','司机','司机信息','司机认证']},
        component: () => import('@/views/digitalLogistics/driverAuthen.vue')
    },
    {
        path: 'driverOrderManage',
        name: {list:['数字物流','订单','订单信息','订单管理']},
        component: () => import('@/views/digitalLogistics/driverOrderManage.vue')
    },
    {
        path: 'driverOrderDetails',
        name: {list:['数字物流','订单','订单信息','订单管理'],title:'订单详情'},
        component: () => import('@/views/digitalLogistics/driverOrderDetails.vue')
    },
    {
        path: 'driverAgreementManage',
        name: {list:['数字物流','设置','内容管理','协议管理']},
        component: () => import('@/views/digitalLogistics/driverAgreementManage.vue')
    },
    {
        path: 'driverKefuTel',
        name: {list:['数字物流','设置','内容管理','客服电话']},
        component: () => import('@/views/digitalLogistics/driverKefuTel.vue')
    },
    {
        path: 'driverRzDetails',
        name: {list:['数字物流','司机','司机信息','司机认证'],title:'认证详情'},
        component: () => import('@/views/digitalLogistics/driverRzDetails.vue')
    },
]